function Preloader() {
    return (
        <div className="preloader">
        </div>
    )
}

export default Preloader